import { Typography } from "@mui/material";

/**
 * Confirmation shown after a registration is submitted.
 *
 * Deliberately **not** a live region. This is a routed page (`/registration-notice`), not
 * something that appears in place beside a form the user is still reading — arriving here is a
 * navigation, and the content is the whole page rather than an update to it. `role="status"`
 * here would announce the page a second time on some AT and imply a pending update that never
 * comes. What it actually needed was what any page needs: a real `<h1>`, so heading order starts
 * at one and the page announces its own name.
 */
export const RegistrationContactNotice = () => {
	return (
		<div style={{ textAlign: "center", marginTop: "20px" }}>
			{/* `variant` keeps the existing h4 sizing; `component` fixes the semantics. */}
			<Typography variant="h4" component="h1" gutterBottom>
				Registration Submitted!
			</Typography>
			<Typography variant="body1">Our team will be in touch with you shortly to complete your registration.</Typography>
			<Typography variant="body2" color="textSecondary" style={{ marginTop: "10px" }}>
				Thank you for your patience.
			</Typography>
		</div>
	);
};
